<template>
  <div class="body" :style="contentStyleObj">
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <div class="content-wrap">
            <div class="input-wrap">
              <div class="user line-warp">
                <!-- <div class="el-icon-user-solid icon"></div> -->
                <el-input
                  class="input-item"
                  prefix-icon="el-icon-user-solid"
                  v-model="user"
                  placeholder="请输入用户名"
                ></el-input>
              </div>
              <div class="pass line-warp">
                <!-- <div class="el-icon-lock icon"></div> -->
                <el-input
                  class="input-item"
                  prefix-icon="el-icon-lock icon"
                  show-password
                  v-model="pass"
                  placeholder="请输入密码"
                ></el-input>
              </div>
              <div class="code line-warp">
                <!-- <div class="code-icon"></div> -->
                <el-input
                  class="input-code"
                  v-model="inCode"
                  placeholder="请输入验证码"
                ></el-input>
                <div class="code-img-wrap" @click="refreshCode">
                  <img :src="code" width="100" height="40" />
                </div>
              </div>
              <div class="btn line-wrap">
                <el-button type="primary" :loading="loading" @click="login"
                  >登录</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      contentStyleObj: {
        height: "",
      },
      user: "",
      pass: "",
      loading: false,
      inCode: "",
      code: "",
      codeList: [],
    };
  },
  methods: {
    ...mapMutations(["changeLogin"]),
    //设置窗口高度
    getHeight() {
      this.contentStyleObj.height = window.innerHeight + "px";
    },

    /**
     * 登录
     */
    async login() {
      let _this = this;
      this.loading = true;
      if (!this.check()) {
        this.loading = false;
        return;
      }
      let params = {
        user_id: this.user,
        password: this.pass,
        code: this.inCode
      };
      let res = await this.$Http.login(params);
      if (res.code == 0) {
        _this.userToken = res.data.token;
        // 将用户token保存到vuex中
        _this.changeLogin({ Authorization: _this.userToken });
        _this.$router.push("/home");
      }else{
        this.$message.error(res.msg);
        this.loading = false;
        this.createdCode();
      }
    },

    /**
     *  验证用户名密码
     */
    check() {
      if (!this.user) {
        this.$message.error("用户名不可以为空!");
        return false;
      }
      if (!this.pass) {
        this.$message.error("密码不能为空!");
        return false;
      }
      return true;
    },

    refreshCode() {
      this.createdCode();
    },
    async createdCode() {
      await this.getVerifyCode();
      let code = this.code;
      let codeList = [];
      for (const i in code) {
        let rgb = [
          Math.round(Math.random() * 220),
          Math.round(Math.random() * 240),
          Math.round(Math.random() * 200),
        ];
        codeList.push({
          code: code[i], // 随机码
          color: `rgb(${rgb})`, // 随机颜色
          fontSize: `1${[Math.floor(Math.random() * 10)]}px`, // 随机字号
          // padding: `${[Math.floor(Math.random() * 10)]}px`, // 随机内边距
          transform: `rotate(${
            Math.floor(Math.random() * 90) - Math.floor(Math.random() * 90)
          }deg)`, // 随机旋转角度
        });
      }
      this.codeList = codeList;
      // 将当前数据派发出去
      this.$emit("update:value", codeList.map((item) => item.code).join(""));
    },
    // 动态绑定样式
    getStyle(data) {
      return `color: ${data.color}; font-size: ${data.fontSize}; padding: ${data.padding}; transform: ${data.transform}`;
    },
    /**
     * 申请验证码
     */
    async getVerifyCode() {
      let res = await this.$Http.getVerifyCode();
      if (res.code == 0) {
        this.code = res.data.code;
      }
    },
  },
  created() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.createdCode();
  },
};
</script>
<style scoped>
.body {
  height: 100%;
  background-image: url(../assets/1.jpg);
  background-repeat: no-repeat;
  background-size: 100%;
}
.content-wrap {
  width: 400px;
  height: 250px;
  margin: auto;
  margin-top: 200px;
  background-color: rgba(0, 0, 0, 0.4);
  /* opacity: 0.5; */
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px #3fbeeb;
  border: 1px solid #74b5c9;
}
.input-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
.line-warp {
  display: flex;
  flex-direction: row;
  height: auto;
  justify-content: center;
  align-items: center;
  /* background-color: #fff; */
}
.line-warp .icon {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  margin-right: 5px;
  border-radius: 4px;
  overflow: hidden;
}
.input-item {
  width: 208px;
}
.input-code {
  width: 100px;
}
.code-img-wrap {
  width: 100px;
  margin-left: 8px;
  box-sizing: border-box;
  /* padding: 0 10px; */
  border-radius: 4px;
  height: 40px;
  display: flex;
  flex-direction: row;
  background-color: aliceblue;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
}
.code-icon {
  width: 40px;
  height: 40px;
  margin-right: 5px;
  border-radius: 4px;
}
</style>
